var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 40,
    viewBox: "0 0 158 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 36940"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "propacity"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2251 33.0481L5.3351 10.8781H8.9951L8.6351 12.8281C9.3551 12.0881 10.2251 11.5181 11.2451 11.1181C12.2651 10.6981 13.3251 10.4881 14.4251 10.4881C16.5651 10.4881 18.2551 11.0881 19.4951 12.2881C20.7351 13.4881 21.3551 15.1181 21.3551 17.1781C21.3551 20.1381 20.3651 22.6681 18.3851 24.7681C16.4251 26.8481 14.0551 27.8881 11.2751 27.8881C9.2951 27.8881 7.7151 27.2381 6.5351 25.9381L5.8751 29.4931C5.8751 29.4931 5.62734 31.1407 4.89453 31.8735C3.30109 33.467 1.2251 33.0481 1.2251 33.0481ZM13.3751 14.1481C11.7551 14.1481 10.3551 14.7581 9.1751 15.9781C8.0151 17.1781 7.4351 18.6081 7.4351 20.2681C7.4351 21.4281 7.8151 22.3781 8.5751 23.1181C9.3351 23.8581 10.3151 24.2281 11.5151 24.2281C12.9951 24.2281 14.3151 23.6181 15.4751 22.3981C16.6551 21.1581 17.2451 19.7681 17.2451 18.2281C17.2451 17.0481 16.8751 16.0781 16.1351 15.3181C15.4151 14.5381 14.4951 14.1481 13.3751 14.1481Z",
    fill: "url(#paint0_linear_1465_7966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0498 27.4981L25.1398 10.8781H28.7998L28.4998 12.4981C29.1598 11.7181 29.7798 11.1881 30.3598 10.9081C30.9398 10.6281 31.6898 10.4881 32.6098 10.4881H32.7898L32.0698 14.3281C29.6898 14.3281 28.2498 15.6381 27.7498 18.2581L26.0398 27.4981H22.0498Z",
    fill: "url(#paint1_linear_1465_7966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9092 10.4881C45.0692 10.4881 46.8392 11.1581 48.2192 12.4981C49.5992 13.8381 50.2892 15.5681 50.2892 17.6881C50.2892 20.3881 49.2092 22.7681 47.0492 24.8281C44.9092 26.8681 42.4192 27.8881 39.5792 27.8881C37.5392 27.8881 35.8192 27.2181 34.4192 25.8781C33.0192 24.5381 32.3192 22.8681 32.3192 20.8681C32.3192 18.1081 33.3792 15.6881 35.4992 13.6081C37.6192 11.5281 40.0892 10.4881 42.9092 10.4881ZM42.2792 14.1481C40.7392 14.1481 39.3792 14.7581 38.1992 15.9781C37.0192 17.1981 36.4292 18.6081 36.4292 20.2081C36.4292 21.3681 36.7992 22.3281 37.5392 23.0881C38.2792 23.8481 39.2292 24.2281 40.3892 24.2281C41.8892 24.2281 43.2292 23.6181 44.4092 22.3981C45.5892 21.1781 46.1792 19.7881 46.1792 18.2281C46.1792 17.0481 45.8092 16.0781 45.0692 15.3181C44.3492 14.5381 43.4192 14.1481 42.2792 14.1481Z",
    fill: "url(#paint2_linear_1465_7966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5733 10.8781L87.5133 27.4981H83.8533L84.2433 25.3381C82.4833 27.0381 80.4833 27.8881 78.2433 27.8881C76.1633 27.8881 74.4833 27.2681 73.2033 26.0281C71.9233 24.7881 71.2833 23.1481 71.2833 21.1081C71.2833 18.1881 72.2933 15.6881 74.3133 13.6081C76.3333 11.5281 78.7833 10.4881 81.6633 10.4881C83.9633 10.4881 85.5833 11.3581 86.5233 13.0981L86.9133 10.8781H90.5733ZM81.3033 14.1481C79.7233 14.1481 78.3433 14.7581 77.1633 15.9781C75.9833 17.1981 75.3933 18.6281 75.3933 20.2681C75.3933 21.5081 75.7533 22.4781 76.4733 23.1781C77.1933 23.8781 78.2033 24.2281 79.5033 24.2281C81.1633 24.2281 82.5533 23.6381 83.6733 22.4581C84.7933 21.2781 85.3533 19.8181 85.3533 18.0781C85.3533 16.8581 84.9933 15.8981 84.2733 15.1981C83.5533 14.4981 82.5633 14.1481 81.3033 14.1481Z",
    fill: "url(#paint3_linear_1465_7966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.388 22.0381H107.888C106.828 23.9181 105.488 25.3681 103.868 26.3881C102.268 27.3881 100.498 27.8881 98.558 27.8881C96.418 27.8881 94.648 27.2181 93.248 25.8781C91.848 24.5381 91.148 22.8481 91.148 20.8081C91.148 18.0881 92.208 15.6881 94.328 13.6081C96.448 11.5281 98.888 10.4881 101.648 10.4881C103.648 10.4881 105.278 10.9981 106.538 12.0181C107.798 13.0381 108.598 14.5081 108.938 16.4281H104.438C103.978 14.9081 102.848 14.1481 101.048 14.1481C99.468 14.1481 98.108 14.7381 96.968 15.9181C95.828 17.0981 95.258 18.5081 95.258 20.1481C95.258 21.3681 95.608 22.3581 96.308 23.1181C97.028 23.8581 97.988 24.2281 99.188 24.2281C100.908 24.2281 102.308 23.4981 103.388 22.0381Z",
    fill: "url(#paint4_linear_1465_7966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.647 27.4981L112.737 10.8781H116.727L113.637 27.4981H109.647ZM113.067 9.07812L113.757 5.32812H117.747L117.057 9.07812H113.067Z",
    fill: "url(#paint5_linear_1465_7966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.454 27.4981L119.854 14.5081H117.904L118.594 10.8781H120.544L121.564 5.32812H125.554L124.534 10.8781H126.934L126.244 14.5081H123.844L121.444 27.4981H117.454Z",
    fill: "url(#paint6_linear_1465_7966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.419 33.0481L130.799 25.9381L127.499 10.8781H132.059L133.739 21.6481L139.769 10.8781H144.359L132.395 30.3099C132.395 30.3099 131.564 31.8006 130.52 32.4985C129.127 33.4296 126.419 33.0481 126.419 33.0481Z",
    fill: "url(#paint7_linear_1465_7966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9751 33.0493L54.0851 10.8793H57.7451L57.3851 12.8293C58.1051 12.0893 58.9751 11.5193 59.9951 11.1193C61.0151 10.6993 62.0751 10.4893 63.1751 10.4893C65.3151 10.4893 67.0051 11.0893 68.2451 12.2893C69.4851 13.4893 70.1051 15.1193 70.1051 17.1793C70.1051 20.1393 69.1151 22.6693 67.1351 24.7693C65.1751 26.8493 62.8051 27.8893 60.0251 27.8893C58.0451 27.8893 56.4651 27.2393 55.2851 25.9393L54.6251 29.4943C54.6251 29.4943 54.3773 31.1419 53.6445 31.8747C52.0511 33.4681 49.9751 33.0493 49.9751 33.0493ZM62.1251 14.1493C60.5051 14.1493 59.1051 14.7593 57.9251 15.9793C56.7651 17.1793 56.1851 18.6093 56.1851 20.2693C56.1851 21.4293 56.5651 22.3793 57.3251 23.1193C58.0851 23.8593 59.0651 24.2293 60.2651 24.2293C61.7451 24.2293 63.0651 23.6193 64.2251 22.3993C65.4051 21.1593 65.9951 19.7693 65.9951 18.2293C65.9951 17.0493 65.6251 16.0793 64.8851 15.3193C64.1651 14.5393 63.2451 14.1493 62.1251 14.1493Z",
    fill: "url(#paint8_linear_1465_7966)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1465_7966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 0,
    width: 14,
    height: 13
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254",
    d: "M143.755 7.43602C143.755 6.02592 144.898 4.88281 146.308 4.88281H150.239L149.872 7.43602H143.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254_2",
    d: "M156.814 4.8843C156.814 6.29439 155.671 7.4375 154.261 7.4375H150.33L150.697 4.8843H156.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254_3",
    d: "M147.814 12.1391C149.204 12.3815 150.526 11.452 150.769 10.063L151.445 6.19039L148.866 6.11295L147.814 12.1391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3254_4",
    d: "M149.916 0.000515891C151.305 0.241856 152.236 1.56374 151.995 2.95303L151.322 6.82615L148.869 6.02749L149.916 0.000515891Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1465_7966)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3255",
    x: 143.754,
    width: 13.1496,
    height: 12.7387,
    fill: "url(#paint9_linear_1465_7966)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1465_7966",
    x1: 61.3106,
    y1: 8.74854,
    x2: 61.395,
    y2: 21.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1465_7966",
    x1: 150.329,
    y1: 0,
    x2: 150.329,
    y2: 12.7387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#D0D5DD",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLogo);
export default __webpack_public_path__ + "static/media/plus_logo.a40a5273e437751683ee1fb7a81117d5.svg";
export { ForwardRef as ReactComponent };